/**
 * Simple CSV Parser Utility
 * Parses a CSV string into an array of objects.
 * Handles basic cases, quotes, and common delimiters (, or ;).
 */

export const parseCSV = (csvText) => {
    const lines = csvText.split(/\r\n|\n/);
    const headers = lines[0].split(/,|;/).map(h => h.trim().replace(/^"|"$/g, ''));

    const result = [];

    for (let i = 1; i < lines.length; i++) {
        const line = lines[i].trim();
        if (!line) continue;

        // Basic split by comma or semicolon, respecting quotes (simplified)
        // Note: A full regex for CSV with commas inside quotes is complex. 
        // For MVP, we assume standard bank CSVs are simple or use semicolons if commas are in values.
        let currentline = line.split(/,|;/);

        // Map to headers
        let obj = {};
        for (let j = 0; j < headers.length; j++) {
            let val = currentline[j] ? currentline[j].trim().replace(/^"|"$/g, '') : '';
            obj[headers[j]] = val;
        }
        result.push(obj);
    }
    return { headers, data: result };
};

/**
 * Helper to normalize currency strings to numbers
 * e.g. "$1,200.50" -> 1200.50
 */
export const cleanCurrency = (str) => {
    if (typeof str === 'number') return str;
    if (!str) return 0;

    // Check for negative parentheses e.g. ($100.00)
    const isNegativeParentheses = /^\(.*\)$/.test(str.trim());

    // Remove $ and , and spaces and parentheses
    const cleanStr = str.replace(/[$, ()]/g, '');
    let val = parseFloat(cleanStr) || 0;

    // Apply negative if detected or if string had minus
    if (isNegativeParentheses || str.includes('-')) {
        val = -Math.abs(val);
    }

    return val;
};
